import { render, staticRenderFns } from "./RecipientTransfer.vue?vue&type=template&id=d0252de8"
import script from "./RecipientTransfer.vue?vue&type=script&lang=js"
export * from "./RecipientTransfer.vue?vue&type=script&lang=js"
import style0 from "./RecipientTransfer.vue?vue&type=style&index=0&id=d0252de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports